import { render, staticRenderFns } from "./PaymentVoucher.vue?vue&type=template&id=23a5632d"
import script from "./PaymentVoucher.vue?vue&type=script&lang=js"
export * from "./PaymentVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports